require('./bootstrap');
import $ from 'jquery';

const getSidebarStatus = () => {
  const sidebarStatus = window.localStorage.getItem('sidebarStatus');

  // Works only on first time page view
  if (sidebarStatus === null) {
    return true;
  }

  return sidebarStatus === 'on';
};

const initSideBarMenu = () => {
  const $mobileMenuBtn = $('.js-btn-menu');
  const $sideBar = $('.js-sidebar');
  const $mainWrapper = $('.js-main');
  const $btnCloseMenu = $('.js-btn-close-menu');

  if (!getSidebarStatus()) {
    $sideBar.addClass('sidebar-hide');
    $mainWrapper.addClass('hidden-menu');
  }

  $mobileMenuBtn.on('click', function () {
    const sidebarStatus = getSidebarStatus();
    window.localStorage.setItem('sidebarStatus', sidebarStatus ? 'off' : 'on');
    $sideBar.toggleClass('sidebar-hide');
    $mainWrapper.toggleClass('hidden-menu');
  });

  $btnCloseMenu.on('click', () => {
    if ($sideBar.hasClass('sidebar-hide')) {
      $sideBar.removeClass('sidebar-hide');
      $mainWrapper.removeClass('hidden-menu');
    }
  });
};

const initCollapseMenuOptions = () => {
  const D_NONE = 'd-none';
  const CHEVRON_UP = 'chevron-up-outline';
  const CHEVRON_DOWN = 'chevron-down-outline';

  $('.collapse').on('show.bs.collapse hide.bs.collapse', function (evt) {
    const $target = $(evt.target);
    const $navItem = $target.closest('.nav-item');
    if (!$navItem.length) {
      return;
    }

    const $navLink = $navItem.find('.nav-link');
    if (!$navLink.length) {
      return;
    }

    const $chevronUp = $navLink.find(`[name="${CHEVRON_UP}"]`);
    const $chevronDown = $navLink.find(`[name="${CHEVRON_DOWN}"]`);
    if (evt.type === 'show') {
      $chevronUp.removeClass(D_NONE);
      $chevronDown.addClass(D_NONE);
    } else if (evt.type === 'hide') {
      $chevronUp.addClass(D_NONE);
      $chevronDown.removeClass(D_NONE);
    }
  });
};

$(function () {
  initSideBarMenu();
  $('[data-toggle="tooltip"]').tooltip();
  initCollapseMenuOptions();
});
